import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, RefreshCw, CheckCircle2, AlertTriangle, Clock, PackageCheck } from 'lucide-react';

export default function ReturnPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-slate-50/50 to-white py-12 px-4 sm:px-6 relative overflow-hidden">
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-rose-500/5 blur-[120px] pointer-events-none rounded-full"></div>

      <div className="max-w-4xl mx-auto space-y-6 relative z-10">
        <div>
          <button
            onClick={() => navigate("/")}
            className="group inline-flex items-center gap-2.5 text-xs font-bold text-slate-600 hover:text-rose-600 bg-white hover:bg-rose-50/50 border border-slate-200/80 px-4 py-2.5 rounded-2xl transition-all duration-200 shadow-sm hover:shadow cursor-pointer"
          >
            <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" /> 
            <span>Quay lại</span>
          </button>
        </div>

        <div className="bg-white/95 backdrop-blur-xl border border-slate-200/80 rounded-3xl p-8 sm:p-12 space-y-8 shadow-2xl shadow-slate-200/50">
          
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-100 pb-6">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-rose-50 text-rose-600 rounded-2xl flex items-center justify-center shrink-0 shadow-inner">
                <RefreshCw className="w-8 h-8" />
              </div>
              <div>
                <span className="text-[11px] font-bold uppercase tracking-widest text-rose-600 bg-rose-50 px-2.5 py-1 rounded-full">
                  Quyền lợi khách hàng
                </span>
                <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 font-serif mt-1.5">
                  Chính Sách Đổi Trả
                </h1>
              </div>
            </div>
            <div className="text-slate-400 text-xs flex items-center gap-1.5 self-start sm:self-center">
              <Clock className="w-3.5 h-3.5" /> Áp dụng toàn quốc
            </div>
          </div>

          <div className="bg-gradient-to-r from-rose-50/60 to-slate-50 border border-rose-100/60 p-5 sm:p-6 rounded-2xl text-slate-700 leading-relaxed text-xs sm:text-sm font-medium">
            Tại <strong className="text-rose-600">JapanICHIBA</strong>, chúng tôi hỗ trợ quý khách đổi trả hàng nhanh chóng trong vòng <span className="text-rose-600 font-bold">07 ngày</span> kể từ thời điểm nhận hàng đối với các sản phẩm chưa qua sử dụng.
          </div>

          <div className="space-y-8 text-xs sm:text-sm text-slate-600 leading-relaxed">
            <div className="space-y-3">
              <h3 className="font-bold text-slate-900 text-base sm:text-lg flex items-center gap-2.5">
                <span className="w-7 h-7 bg-slate-900 text-white rounded-xl flex items-center justify-center text-xs shadow-sm">1</span>
                Điều Kiện Đổi Trả Hợp Lệ
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-1">
                <div className="bg-slate-50/80 border border-slate-200/60 p-4 rounded-2xl space-y-1.5">
                  <span className="font-bold text-slate-900 text-xs uppercase tracking-wide text-rose-600">Thời gian 07 ngày</span>
                  <p className="text-slate-600 text-xs">Tính từ ngày bưu cục xác nhận giao hàng thành công đến quý khách.</p>
                </div>
                <div className="bg-slate-50/80 border border-slate-200/60 p-4 rounded-2xl space-y-1.5">
                  <span className="font-bold text-slate-900 text-xs uppercase tracking-wide text-rose-600">Tình trạng nguyên vẹn</span>
                  <p className="text-slate-600 text-xs">Sản phẩm nguyên tem, hộp, nhãn mác, không bị trầy xước hay đã qua sử dụng.</p>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <h3 className="font-bold text-slate-900 text-base sm:text-lg flex items-center gap-2.5">
                <span className="w-7 h-7 bg-slate-900 text-white rounded-xl flex items-center justify-center text-xs shadow-sm">2</span>
                Các Trường Hợp Được Đổi Trả Miễn Phí
              </h3>
              <ul className="space-y-2 pl-2">
                <li className="flex items-start gap-2.5">
                  <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" />
                  <span>Sản phẩm bị giao sai mẫu mã, thiếu số lượng hoặc nhầm màu so với đơn đặt hàng.</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" />
                  <span>Sản phẩm bị lỗi kỹ thuật xuất phát từ nhà sản xuất hoặc hư hỏng trong quá trình vận chuyển.</span>
                </li>
              </ul>
            </div>

            <div className="space-y-3">
              <h3 className="font-bold text-slate-900 text-base sm:text-lg flex items-center gap-2.5">
                <span className="w-7 h-7 bg-slate-900 text-white rounded-xl flex items-center justify-center text-xs shadow-sm">3</span>
                Lưu Ý Quan Trọng
              </h3>
              <div className="bg-amber-50/50 border border-amber-200/60 p-4 rounded-2xl text-amber-900 text-xs space-y-1.5">
                <p className="font-bold flex items-center gap-1.5"><AlertTriangle className="w-4 h-4 text-amber-600" /> Không áp dụng đổi trả với:</p>
                <p>Các sản phẩm trong chương trình flash sale giảm giá sâu, đồ lót, mỹ phẩm đã bóc seal hoặc sản phẩm đã quá hạn 07 ngày quy định.</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}